import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { setPageHeaderTextActionCreator, setAlertActionCreator } from 'plugins/store/reducers/common.reducer';
import layoutNames from 'utils/enums/layout-names.enum';

// @material-ui
import { ReactComponent as MarketingIcon } from 'assets/img/Menu_Marketing.svg';
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import NavPills from 'components/NavPills/NavPills';
import RouteLeavingGuard from 'components/RouteLeavingGuard/RouteLeavingGuard';

// components
import MarketingEventLogs from './MarketingEventLogs';
import MarketingCreateBroadcast from './MarketingCreateBroadcast';
import MarketingCreateBroadcastFooter from './MarketingCreateBroadcastFooter';

const styles = {
	previewPillsHeader: {
		marginLeft: '25px',
	},
	navPillsWrapper: {
		padding: 0,
	},
};

class Marketing extends Component {
	state = {
		isValidForCreate: false,
		activeTabIndex: 0,
		currentTab: '',
		render: false,
		isUnsavedBroadcast: false,
	};

	viewName = 'Marketing';

	tabIndexByName = {
		'event-logs': 1,
	}

	tabNameByIndex = {
		0: '',
		1: '/event-logs',
	}

	componentDidMount() {
		const { setPageHeaderText, location } = this.props;

		setPageHeaderText(this.viewName);

		const path = (location?.pathname || '').split('/');

		if (path.length === 4 && this.state.activeTabIndex !== this.tabIndexByName[path[3]]) {
			this.setState({
				activeTabIndex: this.tabIndexByName[path[3]],
				render: true,
			});
		} else if (!this.tabIndexByName[path[0]]) {
			this.setState({
				activeTabIndex: 0,
				render: true,
			});
		}
	}

	componentWillUnmount() {
		this.props.setPageHeaderText('');
	}

	setIsValidForCreate = (isValidForCreate) => {
		this.setState({ isValidForCreate });
	}

	setIsUnsavedBroadcast = (isUnsavedBroadcast, callBack = () => {}) => {
		this.setState({ isUnsavedBroadcast }, callBack);
	}

	onBeforeNavPillsChange = async (callBack) => {
		const { setAlert } = this.props;

		if (this.state.isUnsavedBroadcast) {
			const warning = {
				type: 'warning',
				title: 'You have unsaved changes',
				message: 'Are you sure you want to leave the page?',
				confirmBtnText: 'Leave',
				cancelBtnText: 'Stay',
				onConfirm: async () => {
					setAlert(null);
					this.setIsUnsavedBroadcast(false, callBack);
				},
				onCancel: () => {
					setAlert(null);
				},
			};
			setAlert(warning);
		} else {
			callBack();
		}
	};

	onNavPillsChange = (state) => {
		const { history } = this.props;

		history.replace({
			pathname: `/${layoutNames.portal}/marketing${this.tabNameByIndex[state.activeTabIndex || 0]}`,
			state: {
				disableBack: true,
			},
		});

		this.setState({
			activeTabIndex: state.activeTabIndex || 0,
		});
	}

	render() {
		const { classes, history } = this.props;

		return (this.state.render &&
			<>
				<GridContainer>
					<GridItem xs={12}>
						<Card>
							<CardHeader color="primary" icon>
								<CardIcon color="primary">
									<MarketingIcon />
								</CardIcon>
							</CardHeader>
							<CardBody className={classes.navPillsWrapper}>
								<NavPills
									active={this.state.activeTabIndex}
									color="warning"
									onNavPillsChange={this.onNavPillsChange}
									onBeforeNavPillsChange={this.onBeforeNavPillsChange}
									customClasses={classes}
									tabs={[
										{
											tabButton: 'Basic info',
											tabContent: (
												<MarketingCreateBroadcast
													setIsValidForCreate={this.setIsValidForCreate}
													setIsUnsavedBroadcast={this.setIsUnsavedBroadcast}
												/>
											),
										},
										{
											tabButton: 'Event logs',
											tabContent: <MarketingEventLogs />
										}
									]}
								/>
							</CardBody>
						</Card>
						{this.state.activeTabIndex === 0 && <MarketingCreateBroadcastFooter isValidForSend={this.state.isValidForCreate} />}
					</GridItem>
				</GridContainer>
				<RouteLeavingGuard
					when={this.state.isUnsavedBroadcast}
					navigate={(path) => history.push(path)}
					shouldBlockNavigation={() => this.state.isUnsavedBroadcast}
				/>
			</>
		);
	}
}

Marketing.propTypes = {
	classes: PropTypes.object.isRequired,
	history: PropTypes.any.isRequired,
	setPageHeaderText: PropTypes.func.isRequired,
	setAlert: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	setPageHeaderText: bindActionCreators(setPageHeaderTextActionCreator, dispatch),
	setAlert: bindActionCreators(setAlertActionCreator, dispatch),
});

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withRouter,
	withStyles(styles)
)(Marketing);
